// extracted by mini-css-extract-plugin
export default {"container":"popup-header_container__DNABN"};